import React from 'react';
import { Link as DLSLink, Heading, Surface } from '@americanexpress/dls-react';
import { renderHTML } from '../../../../../utilities/render-html';

export function ClickAndGoSuccess(props) {
  const title = props.title;
  const description = props.description;
  const label = props.callToAction.ANCHOR?.label;
  const backURL = `/card-benefits/view-all?account_key=${props?.accountKey}`;
  const safeTitle = renderHTML(title);
  const safeDescription = renderHTML(description);
  const cardname = props?.cardname;
  const benefitTitle = props?.benefitTitle;
  const parseEntities = (txt) => new DOMParser().parseFromString(txt, 'text/html').body.textContent;

  return (
    <Surface variant="base" className="pad-3-lg-up pad-2" data-testid="enroll-page-success">
      {safeTitle && <Heading level={3} variant="text-align-center sans-small-bold"> {safeTitle} </Heading>}
      {safeDescription && <div className="pad-2-tb">  {safeDescription} </div>}
      <DLSLink
        href={backURL}
        id="backtobenefits"
        className="pad-0"
        reactlytics={{ element: `cta>>back-to-benefits>>${cardname}>>${parseEntities(benefitTitle)?.replace(/ /g, '-').toLowerCase()}>>enrollment` }}
        rel="noreferrer"
      >
        {label}
      </DLSLink>
    </Surface>
  );
}
